import React, { Component } from "react";
import { Configuration } from "../Configuration";

function cqcUrl() {
  var base = (Configuration.SYSTEM_SETTINGS || {}).API_URL || "";
  if (base) return base.replace(/\/+$/, "") + "/cqc/";
  return "/cqc/";
}

export default class frmCatalogQualityCheck extends Component {
  constructor(props) {
    super(props);
    this.state = { src: cqcUrl(), error: false };
  }

  render() {
    return (
      <div className="content-wrapper">
        <section
          className="content"
          style={{ padding: 0, height: "calc(100vh / 0.9 - 50px)", position: "relative" }}
        >
          {this.state.error && (
            <div style={{ padding: 30, textAlign: "center", color: "#c33" }}>
              <h4>CQC server is not reachable</h4>
              <p>Make sure the Flask server is running (it auto-starts CQC), then refresh.</p>
            </div>
          )}
          <iframe
            src={this.state.src}
            title="Catalog Quality Check"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: this.state.error ? "none" : "block",
            }}
            onError={() => this.setState({ error: true })}
          />
        </section>
      </div>
    );
  }
}
